import React from 'react';
import css from './SetBudget.module.css';

const LabelField = ({ children }) => (
  <h2 className={css.select}>{children}</h2>
);

export default LabelField;